export default "__VITE_ASSET__DUzdpa$Q__"